import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers'
import {
  IGetUserServicesAction,
  IGetUserServicesNotStartedAction,
  IGetUserServicesSuccessAction,
  IGetUserServicesErrorAction,
} from '../actions/get-user-services'
import { IOpsHubState } from '../state'
import { initialState } from '@telstra-connect/ops-hub/state/initial-state'

type GetUserServicesAction =
  | IGetUserServicesAction
  | IGetUserServicesNotStartedAction
  | IGetUserServicesSuccessAction
  | IGetUserServicesErrorAction

const init = (state: IOpsHubState, action: GetUserServicesAction) => ({
  ...state,
  userServices: {
    ...initialState.userServices,
    status: action.status,
  },
})

const success = (state: IOpsHubState, action: GetUserServicesAction) => {
  return {
    ...state,
    userServices: {
      ...initialState.userServices,
      status: action.status,
      data: (action as IGetUserServicesSuccessAction).data,
    },
  }
}

const failure = (state: IOpsHubState, action: GetUserServicesAction) => ({
  ...state,
  userServices: {
    ...initialState.userServices,
    status: action.status,
    error: (action as IGetUserServicesErrorAction).error,
  },
})

const reset = (state: IOpsHubState, action: GetUserServicesAction) => {
  return {
    ...state,
    userServices: {
      ...initialState.userServices,
      status: action.status,
      error: null,
    },
  }
}

export const getUserServicesReducer = createAsyncReducer(initialState, init, success, failure, reset)
